import { InjectionKey, Ref } from 'vue';

export interface SortOrderState {
  sort: Readonly<Ref<string>>;
  order: Readonly<Ref<string>>;
}

export const SortOrderInjectionKey: InjectionKey<SortOrderState> = Symbol('SortOrderState');

export const RefreshDocumentListKey: InjectionKey<() => void> = Symbol('RefreshDocumentList');
